/* eslint-disable */
class Utils {
  /**
   * Get the closest matching element up the DOM tree.
   * @private
   * @param  {Element} elem     Starting element
   * @param  {String}  selector Selector to match against
   * @return {Boolean|Element}  Returns null if not match found
   */
  static getClosest(elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function(s) {
          const matches = (this.document || this.ownerDocument).querySelectorAll(s);
          let i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        };
    }

    // Get closest match
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return elem;
    }

    return null;
  }

  static setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  }
  static getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  static eraseCookie(name) {
    document.cookie = `${name}=; Max-Age=-99999999;`;
  }

  static fadeIn(el, display) {
    console.log('fadein: ', el);
    el.style.opacity = 0;
    el.style.display = display || 'block';

    (function fade() {
      let val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
    })();
  }

  /**
   * Slide an element down like jQuery's slideDown function using CSS3 transitions.
   * @see https://gist.github.com/ludder/4226288
   * @param  {element}  el
   * @param  {string}   timing
   * @return {void}
   */
  static slideDown(el, timing) {
    timing = timing || '300ms ease';

    // Get element height
    el.style.webkitTransition = 'initial';
    el.style.transition = 'initial';
    el.style.visibility = 'hidden';
    el.style.maxHeight = 'initial';
    const height = `${el.offsetHeight}px`;
    el.style.removeProperty('visibility');
    el.style.maxHeight = '0';
    el.style.overflow = 'hidden';

    // Begin transition
    el.style.webkitTransition = `max-height ${timing}, opacity ${timing}`;
    el.style.transition = `max-height ${timing}, opacity ${timing}`;
    var endSlideDown = function() {
      el.style.removeProperty('-webkit-transition');
      el.style.removeProperty('transition');
      el.removeEventListener(transitionEvent('end'), endSlideDown);
    };
    requestAnimationFrame(() => {
      el.addEventListener(transitionEvent('end'), endSlideDown);
      el.style.maxHeight = height;
      el.style.opacity = '1';
    });
  }
  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  static debounce(func, wait, immediate) {
    let timeout;
    return function() {
      let context = this,
        args = arguments;
      const later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
}

export default Utils;
